import axios from "axios";
import { toast } from "react-toastify";

const IS_PRODUCTION = true;

//  let BASE_URL = "http://localhost:5000/api/";
// // let BASE_URL = "http://ec2-13-127-183-67.ap-south-1.compute.amazonaws.com/api/";
const BASE_URL = IS_PRODUCTION ? "https://api.indiaesa.info/api/" : "http://localhost:5000/api/";

//UAT base URL
// const BASE_URL = "https://uatapi.indiaesa.info/api/";

export const INVOICE_URL = `${BASE_URL}`;

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
  token?: any;
  responseType?: "json" | "blob";
}

const WebService = {
  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          },
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    // eslint-disable-line
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  getAccesstoken: function (props: PropData) {
    // eslint-disable-line
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          localStorage.setItem("token", "Bearer " + response.data.data.token);
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .get(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileUploadPutAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    if (error?.response) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.error_description;
    }
    toast.error(errorMessage);
    return errorMessage;
  },

  getBlobAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: props.token
          ? props.token
          : localStorage.getItem("token"),
      };

      axios
        .get(`${BASE_URL}${props.action}`, {
          headers,
          responseType: "blob", // 🔥 KEY
        })
        .then((response) => {
          resolve(response); // 🔥 FULL RESPONSE
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default WebService;
